/* DO NOT EDIT THIS FILE MANUALLY
USE PRODUCTION ENVIRONMENT TO UPDATE THIS FILE

bun run src/scripts/taxonomies/generate_taxonomies_cache.ts

*/

import { TaxonomyTag, type Taxonomy } from "#/types/types";

export const taxonomiesCache: Taxonomy[] = [
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 9,
    name: "Anesthesiologist",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "anesthesiologist",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: [38, 49],
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 10,
    name: "Radiologist",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "radiologist",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 11,
    name: "Hospitalist",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "hospitalist",
    keyPhrases: ["hospitalist"],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 12,
    name: "Neonatologist",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "neonatologist",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 13,
    name: "Cardiologist",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "cardiologist",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 14,
    name: "Neurologist",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "neurologist",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: [38, 52],
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 15,
    name: "Pediatrician",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "pediatrician",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: [38, 53],
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 16,
    name: "Primary Care Physician",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "primary-care-physician",
    keyPhrases: ["PCP"],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: [38, 62],
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 17,
    name: "Emergency Medicine Physician",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: [38, 57],
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 18,
    name: "Urgent Care Physician",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "urgent-care-physician",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: [38, 56],
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 19,
    name: "Family Medicine Physician",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "family-medicine-physician",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: [38, 64],
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 20,
    name: "Internal Medicine Physician",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "internal-medicine-physician",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: [38, 63],
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 48,
    name: "Physician Assistant",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "physician-assistant",
    keyPhrases: ["physician assistant", "PA"],
    penaltyPhrases: [],
    tags: [TaxonomyTag.ASSISTANT],
    composedOf: [38, 125],
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 23,
    name: "Dermatologist",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "dermatologist",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 24,
    name: "Endocrinologist",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "endocrinologist",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 25,
    name: "Gastroenterologist",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "gastroenterologist",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 26,
    name: "Hematologist",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "hematologist",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 27,
    name: "Infectious Disease Specialist",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "infectious-disease-specialist",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 28,
    name: "Nephrologist",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "nephrologist",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 29,
    name: "Oncologist",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "oncologist",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 30,
    name: "Pulmonologist",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "pulmonologist",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 31,
    name: "Rheumatologist",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "rheumatologist",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 32,
    name: "Urologist",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "urologist",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 33,
    name: "Ophthalmologist",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "ophthalmologist",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 34,
    name: "Otolaryngologist",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "otolaryngologist",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 35,
    name: "Psychiatrist",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "psychiatrist",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 36,
    name: "Allergist",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "allergist",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 37,
    name: "Pathologist",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "pathologist",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 38,
    name: "Physician",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "physician",
    keyPhrases: ["medical doctor", "MD", "doctor"],
    penaltyPhrases: ["assistant"],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 39,
    name: "Nurse",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "nurse",
    keyPhrases: ["nurse"],
    penaltyPhrases: [],
    tags: [],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 40,
    name: "Advanced Practice Registered Nurse",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "aprn",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 44,
    name: "Clinical Nurse Specialist",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "clinical-nurse-specialist",
    keyPhrases: ["CNS"],
    penaltyPhrases: [],
    tags: [TaxonomyTag.NURSE],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 45,
    name: "Certified Nurse-Midwife",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "certified-nurse-midwife",
    keyPhrases: ["CNM"],
    penaltyPhrases: [],
    tags: [TaxonomyTag.NURSE],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 46,
    name: "EM Physcian Assistant",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "emergency-medicine",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.ASSISTANT],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 57,
    name: "Emergency Medicine",
    acronym: "EM",
    abbreviation: null,
    primaryNameType: 1,
    slug: "emergency-medicine",
    keyPhrases: ["emergency medicine", "EM"],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 49,
    name: "Anesthesiology",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "anesthesiology",
    keyPhrases: ["anesthesia", "anes"],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 50,
    name: "Cardiology",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "cardiology",
    keyPhrases: ["cardiac"],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 51,
    name: "Radiology",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "radiology",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 52,
    name: "Neurology",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "neurology",
    keyPhrases: ["neurology", "nero"],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 53,
    name: "Pediatric",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "pediatric",
    keyPhrases: ["peds"],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 54,
    name: "Critical Care",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "critical-care",
    keyPhrases: ["CC"],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 55,
    name: "Trauma",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "trauma",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 56,
    name: "Urgent Care",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "urgent-care",
    keyPhrases: ["UC", "urgent care"],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 42,
    name: "Nurse Practitioner",
    acronym: "NP",
    abbreviation: null,
    primaryNameType: 1,
    slug: "nurse-practitioner",
    keyPhrases: ["nurse practitioner", "NP"],
    penaltyPhrases: [],
    tags: [TaxonomyTag.NURSE],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 58,
    name: "Hospital Medicine",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "hospital-medicine",
    keyPhrases: ["HM"],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 59,
    name: "OBGYN",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "obgyn",
    keyPhrases: [
      "OBGYN",
      "obgyn",
      "OB/GYN",
      "gynecology",
      "obstetrics",
      "ob gyn",
    ],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 60,
    name: "Chief",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "chief",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 61,
    name: "Academic",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "academic",
    keyPhrases: ["academia"],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 21,
    name: "Intensivist",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "intensivist-critical-care",
    keyPhrases: ["intensivist", "critical care physician"],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 43,
    name: "Registered Nurse",
    acronym: "RN",
    abbreviation: null,
    primaryNameType: 1,
    slug: "registered-nurse",
    keyPhrases: ["RN"],
    penaltyPhrases: [],
    tags: [TaxonomyTag.NURSE],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 72,
    name: "Infectious Disease",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "infectious-disease",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 73,
    name: "Nephrology",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "nephrology",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 74,
    name: "Oncology",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "oncology",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 6,
    name: "Neurosurgeon",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "neurosurgeon",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: [4, 134],
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 7,
    name: "Trauma Surgeon",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "trauma-surgeon",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: [4, 55],
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 8,
    name: "Critical Care Surgeon",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "critical-care-surgeon",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: [4, 54],
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 2,
    name: "Cardiothoracic Surgeon",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "cardiothoracic-surgeon",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: [4, 135],
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 3,
    name: "General Surgeon",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "general-surgeon",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: [4, 122],
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 75,
    name: "Pulmonology",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "pulmonology",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 76,
    name: "Rheumatology",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "rheumatology",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 77,
    name: "Urology",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "urology",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 78,
    name: "Ophthalmology",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "ophthalmology",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 79,
    name: "Otolaryngology",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "otolaryngology",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 80,
    name: "Psychiatry",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "psychiatry",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 81,
    name: "Allergy and Immunology",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "allergy-and-immunology",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 82,
    name: "Pathology",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "pathology",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 84,
    name: "Moonlighting",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description:
      "Physicians or nurses working additional jobs outside their main employment, often at other hospitals.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 85,
    name: "Non-Invasive",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description:
      "Procedures that do not require incisions into the body or removal of tissue.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 86,
    name: "Private Practice",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description:
      "Practice of medicine by a group or individual not directly affiliated with a hospital.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 87,
    name: "Interventional",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description:
      "Specializes in minimally invasive procedures guided by imaging.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 88,
    name: "Congenital Heart",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: "Focus on heart defects that are present from birth.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 89,
    name: "Freestanding Emergency Department",
    acronym: "FSED",
    abbreviation: null,
    primaryNameType: 2,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description:
      "Emergency care facility that operates independently of a hospital.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 90,
    name: "Rehabilitation Inpatient",
    acronym: null,
    abbreviation: null,
    primaryNameType: 2,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description:
      "Rehabilitation services provided in a hospital or clinic where patients stay overnight.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 91,
    name: "Licensed Vocational",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: "Licensed Vocational medical or healthcare services.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 92,
    name: "Licensed Practical Nurse",
    acronym: "LPN",
    abbreviation: null,
    primaryNameType: 2,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.NURSE],
    composedOf: null,
    description:
      "Provides basic nursing care under the supervision of a registered nurse or doctor.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 93,
    name: "Licensed Vocational Nurse",
    acronym: "LVN",
    abbreviation: null,
    primaryNameType: 2,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.NURSE],
    composedOf: null,
    description:
      "Provides basic nursing care under the supervision of a registered nurse or doctor.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 94,
    name: "Intensive Care Unit",
    acronym: "ICU",
    abbreviation: null,
    primaryNameType: 2,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description:
      "Special department of a hospital that provides intensive treatment medicine.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 95,
    name: "Coordinator",
    acronym: null,
    abbreviation: "Coord",
    primaryNameType: 1,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description:
      "Oversees the administration and day-to-day activities of healthcare facilities or clinical trials.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 96,
    name: "Laboratory Preperation",
    acronym: null,
    abbreviation: "Lab Prep",
    primaryNameType: 3,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description:
      "Involves preparing and organizing laboratory tests and procedures.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 97,
    name: "Total Joint",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description:
      "Focus on surgery that involves total joint replacements, such as knees and hips.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 98,
    name: "Rural",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description:
      "Medical practice or services provided in rural areas, often with limited resources.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 99,
    name: "Operating Room",
    acronym: "OR",
    abbreviation: null,
    primaryNameType: 2,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description:
      "Facility within a hospital where surgical operations are carried out.",
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 41,
    name: "Certified Registered Nurse Anesthetist",
    acronym: "CRNA",
    abbreviation: "Nurse Anesthetist",
    primaryNameType: 2,
    slug: "crna",
    keyPhrases: [
      "CRNA",
      "nurse anesthetist",
      "certified registered nurse anesthetist",
    ],
    penaltyPhrases: [],
    tags: [TaxonomyTag.NURSE],
    composedOf: [43, 126, 131],
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 22,
    name: "OBGYN Physician",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: null,
    keyPhrases: ["obstetrician", "gynecologist", "maternal fetal medicine"],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: [38, 59],
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 47,
    name: "Anesthesiologist Assistant",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: null,
    keyPhrases: [
      "anesthesiologist physician assistant",
      "certified anesthesiologist assistant",
      "CAA",
      "APA",
    ],
    penaltyPhrases: [],
    tags: [TaxonomyTag.ASSISTANT],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 62,
    name: "Primary Care",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "primary-care",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 63,
    name: "Internal Medicine",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "internal-medicine",
    keyPhrases: ["IM"],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 64,
    name: "Family Medicine",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "family-medicine",
    keyPhrases: ["FM"],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 65,
    name: "Nocturnist",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "nocturnist",
    keyPhrases: ["noct", "nocturnal", "nocturnalist"],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 66,
    name: "Telemedicine",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "telemedicine",
    keyPhrases: ["telemed"],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 67,
    name: "Maternal Fetal Medicine",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: null,
    keyPhrases: ["maternal fetal medicine", "MFM"],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 68,
    name: "Dermatology",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "dermatology",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 69,
    name: "Endocrinology",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "endocrinology",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 70,
    name: "Gastroenterology",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "gastroenterology",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 71,
    name: "Hematology",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "hematology",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 100,
    name: "Float Pool",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.NURSE],
    composedOf: null,
    description:
      "Group of nurses who work in different departments as needed, rather than being assigned to a specific unit.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 101,
    name: "Residency",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description:
      "Graduate medical training in a specialty, which doctors undertake after finishing medical school.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 102,
    name: "Labor and Delivery",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description:
      "Specialized care involving childbirth and the immediate postpartum period.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 103,
    name: "Progressive Care Unit",
    acronym: "PCU",
    abbreviation: null,
    primaryNameType: 2,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description:
      "Provides care for patients requiring close monitoring but not at the level of intensive care.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 104,
    name: "Cardiovascular Thoracic Surgery",
    acronym: "CVTS",
    abbreviation: null,
    primaryNameType: 2,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description:
      "Specialized surgical treatment of organs inside the thorax (the chest), primarily the heart and lungs.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 105,
    name: "Pediatric Intensive Care Unit",
    acronym: "PICU",
    abbreviation: null,
    primaryNameType: 2,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description:
      "Provides critically needed care for infants, children, and teenagers.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 106,
    name: "Post Anesthesia Care Unit",
    acronym: "PACU",
    abbreviation: null,
    primaryNameType: 2,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description:
      "Where patients are monitored as they recover from the effects of anesthesia.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 107,
    name: "PRN",
    acronym: null,
    abbreviation: null,
    primaryNameType: 2,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description:
      "Refers to administering medication as needed, or a healthcare worker who works when called.",
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 1,
    name: "Orthopedic Surgeon",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "orthopedic-surgeon",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: [4, 83],
    description: null,
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 108,
    name: "Emergency Department",
    acronym: "ED",
    abbreviation: null,
    primaryNameType: 1,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description:
      "Hospital or primary care department that provides initial treatment to patients with a broad spectrum of illnesses and injuries.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 109,
    name: "Catheterization Laboratory",
    acronym: null,
    abbreviation: "Cath Lab",
    primaryNameType: 3,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description:
      "Specialized area of the hospital where doctors perform minimally invasive tests and procedures to diagnose and treat cardiovascular disease.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 110,
    name: "Stroke",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description:
      "Specialized unit that treats and manages patients suffering from stroke conditions.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 111,
    name: "New Graduate",
    acronym: null,
    abbreviation: "New Grad",
    primaryNameType: 1,
    slug: null,
    keyPhrases: ["recent grad", "recent graduate"],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description:
      "Recently graduated nurse or physician starting their first professional role.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 112,
    name: "Telemetry",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description:
      "Monitoring of patient's vital signs remotely, often used in cardiac care.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 113,
    name: "Endoscopy",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description:
      "Use of specialized cameras and instruments to view the gastrointestinal tract and other internal organs.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 114,
    name: "Acute Care",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: null,
    keyPhrases: ["acute"],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description:
      "Immediate and urgent care provided for severe and sudden onset of symptoms or illness.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 115,
    name: "Neonatal Intensive Care Unit",
    acronym: "NICU",
    abbreviation: null,
    primaryNameType: 2,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description:
      "Specialized unit that cares for ill or premature newborn infants.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 116,
    name: "Stepdown",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: null,
    keyPhrases: ["step down"],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description:
      "Hospital unit that provides an intermediate level of care between the ICU and the general medical wards.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 117,
    name: "Rapid Response Team",
    acronym: "RRT",
    abbreviation: null,
    primaryNameType: 2,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description:
      "A group of highly skilled clinicians who respond to emergency situations within the hospital to prevent patient deterioration.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 118,
    name: "Outpatient",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description:
      "Medical procedures or tests that can be done in a medical center without an overnight stay.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 119,
    name: "Recovery Room",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description:
      "Where patients are monitored post-surgery as they recover from anesthesia.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 120,
    name: "Family Nurse Practitioner",
    acronym: "FNP",
    abbreviation: null,
    primaryNameType: 2,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.NURSE],
    composedOf: null,
    description:
      "A nurse practitioner who provides ongoing and comprehensive healthcare for the individual and family across all ages, diseases, and parts of the body.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 121,
    name: "Emergency Room",
    acronym: "ER",
    abbreviation: null,
    primaryNameType: 2,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description:
      "Department of a hospital that provides immediate treatment for acute illnesses and injuries.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 122,
    name: "General",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: "General medical or healthcare services.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 123,
    name: "Advanced",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: "Advanced medical or healthcare services.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 124,
    name: "Associate",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: "Associate medical or healthcare services.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 125,
    name: "Assistant",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: "Assistant medical or healthcare services.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 126,
    name: "Certified",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: "Certified medical or healthcare services.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 127,
    name: "Clinical",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: "Clinical medical or healthcare services.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 128,
    name: "Laboratory",
    acronym: null,
    abbreviation: "Lab",
    primaryNameType: 3,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: "Laboratory medical or healthcare services.",
  },
  {
    createdAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed Apr 17 2024 15:15:56 GMT-0700 (Mountain Standard Time)",
    ),
    id: 129,
    name: "Rehabilitation",
    acronym: null,
    abbreviation: "Rehab",
    primaryNameType: 3,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: "Rehabilitation medical or healthcare services.",
  },
  {
    createdAt: new Date(
      "Sat Apr 20 2024 11:41:50 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 20 2024 11:41:50 GMT-0700 (Mountain Standard Time)",
    ),
    id: 131,
    name: "Anesthetist",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: "A person specially trained to administer anesthetics.",
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 4,
    name: "Surgeon",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "surgeon",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: [38, 132],
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 5,
    name: "Vascular Surgeon",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "vascular-surgeon",
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.PHYSICIAN],
    composedOf: [4, 133],
    description: null,
  },
  {
    createdAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Sat Apr 13 2024 15:33:09 GMT-0700 (Mountain Standard Time)",
    ),
    id: 83,
    name: "Orthopedic",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: "orthopedic",
    keyPhrases: ["orthopaedic", "ortho"],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Wed May 08 2024 16:12:27 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed May 08 2024 16:12:27 GMT-0700 (Mountain Standard Time)",
    ),
    id: 134,
    name: "Neurosurgery",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: [52, 132],
    description: null,
  },
  {
    createdAt: new Date(
      "Wed May 08 2024 16:05:14 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed May 08 2024 16:05:14 GMT-0700 (Mountain Standard Time)",
    ),
    id: 132,
    name: "Surgery",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Wed May 08 2024 16:10:04 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed May 08 2024 16:10:04 GMT-0700 (Mountain Standard Time)",
    ),
    id: 133,
    name: "Vascular",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
  {
    createdAt: new Date(
      "Wed May 08 2024 16:19:39 GMT-0700 (Mountain Standard Time)",
    ),
    updatedAt: new Date(
      "Wed May 08 2024 16:19:39 GMT-0700 (Mountain Standard Time)",
    ),
    id: 135,
    name: "Cardiothoracic",
    acronym: null,
    abbreviation: null,
    primaryNameType: 1,
    slug: null,
    keyPhrases: [],
    penaltyPhrases: [],
    tags: [TaxonomyTag.SPECIALTY],
    composedOf: null,
    description: null,
  },
];
